<template>
  <i v-if="iconComponent" class="svg-icon">
    <component :is="iconComponent" />
  </i>
  <span v-else-if="icon" class="menu-icon">{{ icon }}</span>
</template>

<script lang="ts">
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const iconComponent = computed(() => {
      if (!props.icon) return null;

      // 尝试查找Element Plus图标组件
      const iconKey = Object.keys(ElementPlusIconsVue).find(
        (key) => key.toLowerCase() === props.icon.toLowerCase(),
      );

      return iconKey ? ElementPlusIconsVue[iconKey as keyof typeof ElementPlusIconsVue] : null;
    });

    return {
      iconComponent,
    };
  },
});
</script>

<style scoped lang="scss">
.svg-icon {
  width: 1em;
  height: 1em;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  :deep(svg) {
    width: 1em;
    height: 1em;
  }
}

.menu-icon {
  font-size: 14px;
}
</style>
